import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles, Crown } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Subscription = () => {
  const { user, logout, updateSubscription } = useAuth();
  const navigate = useNavigate();
  const STRIPE_LINK = "https://buy.stripe.com/aFaeVedeD9wkdfF7Cqebu0b";

  const handleSubscribe = () => {
    // Open Stripe link in new tab
    window.open(STRIPE_LINK, '_blank');
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4"
      style={{
        background: 'linear-gradient(140deg, #08101e 0%, #0f172a 55%, #0b3b4b 100%)'
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-2xl"
      >
        {/* Header */}
        <div className="text-center mb-12">
          <motion.div
            className="inline-block mb-4"
            animate={{
              rotate: [0, 10, -10, 10, 0]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatDelay: 3
            }}
          >
            <Crown size={48} style={{ color: 'var(--accent-cyan)' }} />
          </motion.div>
          <h1
            className="text-4xl font-bold mb-4"
            style={{
              background: 'linear-gradient(135deg, var(--accent-cyan) 0%, var(--accent-ocean) 50%, var(--accent-mint) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            Débloquez Coach Life Premium
          </h1>
          <p className="text-lg" style={{ color: 'var(--text-secondary)' }}>
            Accédez à toutes les fonctionnalités de votre coach IA personnel
          </p>
        </div>

        {/* Pricing Card */}
        <div
          className="backdrop-blur-xl rounded-2xl p-8 border relative overflow-hidden"
          style={{
            background: 'rgba(var(--bg-elev-1), 0.8)',
            borderColor: 'var(--accent-cyan)'
          }}
        >
          {/* Glow effect */}
          <div
            className="absolute inset-0 opacity-20"
            style={{
              background: 'radial-gradient(circle at top right, var(--accent-cyan) 0%, transparent 60%)'
            }}
          />

          <div className="relative z-10">
            {/* Features */}
            <div className="mb-8 space-y-4">
              {[
                'Conversations illimitées avec l\'IA',
                'Mode vocal en temps réel',
                'Analyse d\'images et de fichiers',
                'Support multilingue (16 langues)',
                'Historique complet des conversations',
                'Accès prioritaire aux nouvelles fonctionnalités'
              ].map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <div
                    className="w-6 h-6 rounded-full flex items-center justify-center"
                    style={{ background: 'var(--accent-mint)' }}
                  >
                    <Check size={16} style={{ color: '#0b1220' }} />
                  </div>
                  <span style={{ color: 'var(--text-primary)' }}>{feature}</span>
                </motion.div>
              ))}
            </div>

            {/* CTA Button */}
            <button
              onClick={handleSubscribe}
              className="w-full py-4 rounded-lg font-bold text-lg transition-all flex items-center justify-center gap-2 hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, var(--accent-cyan) 0%, var(--accent-ocean) 100%)',
                color: '#0b1220',
                boxShadow: '0 10px 30px rgba(6, 182, 212, 0.3)'
              }}
            >
              <Sparkles size={20} />
              S'abonner maintenant
            </button>

            {/* Logout */}
            <div className="mt-6 text-center">
              <button
                onClick={logout}
                className="text-sm hover:underline"
                style={{ color: 'var(--text-muted)' }}
              >
                Se déconnecter
              </button>
            </div>
          </div>
        </div>

        {/* Trust badges */}
        <div className="mt-8 text-center">
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            🔒 Paiement sécurisé via Stripe • Annulation à tout moment
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Subscription;
